import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import {
    addFromColumn,
    convertStartEndDatesForFile,
    parseCurrency,
    sortArrayByKey,
    toCurrency,
} from '../shared/functions';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import PaymentTableIcon from 'material-ui/svg-icons/editor/attach-money';

const paymentLabels = {
    cash: 'Cash',
    credit_card: 'Credit Card',
    loyalty_points: 'Loyalty Points',
    out_of_scope: 'Credit Card'
};

/**
 * Class for displaying Detailed Sales Payment Summary in a table
 *
 */
class DetailedSalesReportPaymentSummaryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listTableData: [],
            tableHeaders: [
                {label: 'Payment Type', key: 'label'},
                {label: 'Total Payments', key: 'totalPayments'},
                {label: 'Gross Sales', key: 'salesGross'},
            ],
            summaryComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: [],
                summaryComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    processData(data) {
        let listData = [];
        if (data) {
            // Assemble Payment Summary rows
            for (let i = 0; i < data.length; i++) {
                let p = data[i];
                let row = {
                    index: 0,
                    key: p.key,
                    label: paymentLabels[p.key],
                    salesGross: (p.gross_total && p.gross_total.value) ? toCurrency(p.gross_total.value, true) : toCurrency(0),
                    totalPayments: (p.count && p.count.value) ? p.count.value : 0
                };
                if (p.key === 'out_of_scope') {
                    row.index = 1;
                }
                if (p.key === 'loyalty_points') {
                    row.index = 2;
                    row.salesGross = (p.gross_total && p.gross_total.value) ? toCurrency((p.gross_total.value) * 0.1, true) : toCurrency(0);
                }
                listData.push(row);
            }

            // Combine Credit Card and Out of Scope
            let ccIdx = listData.findIndex(r => r.key === 'credit_card');
            let oosIdx = listData.findIndex(r => r.key === 'out_of_scope');
            if (ccIdx !== -1 && oosIdx !== -1) {
                listData[oosIdx].totalPayments = listData[ccIdx].totalPayments + listData[oosIdx].totalPayments;
                let ccSales = parseCurrency(listData[ccIdx].salesGross);
                let oosSales = parseCurrency(listData[oosIdx].salesGross);
                listData[oosIdx].salesGross = toCurrency(ccSales + oosSales);
                listData.splice(ccIdx, 1);
            }
            listData = sortArrayByKey(listData, 'index', 'ASC');
        }

        // Finalize table data
        this.setState({
            listTableData: listData,
            summaryComplete: true
        }, () => {
            if (typeof this.props.onSummaryComplete === 'function') {
                this.props.onSummaryComplete('payment', true);
            }
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            endDate,
            locationId,
            startDate,
            system
        } = this.props;

        const {
            listTableData,
            tableHeaders,
            summaryComplete
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);

        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Payment Type',
                        accessor: 'label',
                        Footer: (<span style={tableStyles.footer}>Totals:</span>)
                    },
                    {
                        Header: 'Total Payments',
                        accessor: 'totalPayments',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(listTableData, 'totalPayments')}
                            </span>
                        )
                    },
                    {
                        Header: 'Gross Sales',
                        accessor: 'salesGross',
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(listTableData, 'salesGross'))}
                            </span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                {!summaryComplete &&
                    <div className="loader-container">
                        <h4>Generating Report...</h4>
                        <CircularProgress
                            size={24}
                            thickness={2}
                            className="loader"
                        />
                    </div>
                }
                {summaryComplete &&
                    <div className="reports-table-container">

                        {/* Table Header: Detailed Sales Payment Summary */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container report-header-button-container">
                                {/* Export Payment Summary */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={commonStyles.headerButton}
                                >
                                    <ExportIcon style={commonStyles.headerButtonIcon}/>
                                    <CSVLink
                                        data={listTableData}
                                        headers={tableHeaders}
                                        filename={'Detailed-Sales-Payments-' + system + '-' + locationId + '-' + dateString + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={commonStyles.headerButtonLink}
                                    >
                                        Export Payment Summary
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <PaymentTableIcon style={commonStyles.summaryIcon}/>
                                <span>Payment Summary</span>
                            </h3>
                        </div>

                        {/* Table: Payment Summary */}
                        <ReactTable
                            key="table-detailed-payment-summary"
                            data={listTableData}
                            columns={tableColumns}
                            defaultPageSize={10}
                            showPagination={false}
                            sortable={false}
                            resizable={false}
                            minRows={1}
                            className="-striped"
                        />
                    </div>
                }
            </div>
        )
    }
}

DetailedSalesReportPaymentSummaryTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string.isRequired,
    listData: PropTypes.array,
    locationId: PropTypes.string.isRequired,
    onSummaryComplete: PropTypes.func,
    startDate: PropTypes.string.isRequired,
    system: PropTypes.string,
};

DetailedSalesReportPaymentSummaryTable.defaultProps = {
    addField: true,
    endDate: null,
    listData: [],
    locationId: null,
    startDate: null,
};

export default DetailedSalesReportPaymentSummaryTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/DetailedSalesReportPaymentSummaryTable.js